export const CHAIN_NAME: string = `${process.env.REACT_APP_NETWORK_NAME}`;